import { useEffect, useState } from "react";
import { createBase, createSelectors } from './base';
import { request } from "@/utils/useRequest";

const initState = {
    inited: false,
    windowHeight: window.innerHeight,
    windowWidth: window.innerWidth,
    area: [],
    areatree: null,
    rolelist: [],
    sysdicts: [],
    menus: [],
    funcs: [],
    user: null,
    topmenu_id: 0,
    route_navigate: undefined,
    primaryColor: '#791A3E', // 默认主题色
};

export const commonBaseStore =
    createBase(
        (set, get) => ({
            ...initState,
            login: async (uid, pwd) => {
                const requestUrl = '/api/v2/public/login';
                const result = await request(requestUrl, "POST", "json", { uid, pwd, rememberMe: true, returnUrl: "/" });
                if (result.success) {
                    //localStorage.user = JSON.stringify(result.data);
                    set(state => {
                        state.user = {
                            ...result.data,
                            //auth:{name:result.data.Id,token:result.data.token}
                        };
                    });
                }
                return result;
            },
            logout: () => {
                set(state => {
                    state.user = null;
                });
                return true;
            },
            initFn: async () => {
                //const { request } = UseRequest();
                const result = await request("/api/v2/private/initdata/get", "POST", "json", {});
                if (result.success) {

                    //地区树
                    let filter1 = (pid) => {
                        let tt = result.data.Area.filter(item => item.ParentCode === pid);
                        let st = tt.sort((a, b) => {
                            if (a.Code < b.Code) return -1;
                            if (a.Code > b.Code) return 1;
                            return 0;
                        });
                        st.forEach(itm => {
                            itm.children = filter1(itm.Code);
                        });
                        return st;
                    };
                    let areatree = filter1("000000");

                    set(state => {
                        const userData = { ...result.data.user, auth: state.user.auth };
                        const areaData = result.data.Area;
                        const roleListData = result.data.CustomerRole;
                        const sysDictsData = result.data.SysDict.map(item => ({ ...item, Data: JSON.parse(item.Data) }));
                        const areaTreeData = areatree;
                        delete userData.__headers__;
                        delete userData.__user__;

                        // 检查数据是否有效
                        if (userData && areaData && roleListData && sysDictsData && areaTreeData) {
                            state.user = userData;
                            state.area = areaData;
                            state.rolelist = roleListData;
                            state.sysdicts = sysDictsData;
                            state.areatree = areaTreeData;
                            state.inited = true;
                        } else {
                            console.error("Invalid data detected, skipping state update.");
                        }
                    });
                }
            },
            getMenu: async () => {
                const result = await request("/api/v2/private/menu/all", "POST", "json", {});
                if (result.success) {
                    const menus = result.data;
                    const funcs = [];
                    menus.forEach(menu => {
                        if (Array.isArray(menu.FuncInfos)) {
                            funcs.push(...menu.FuncInfos.map(item => item.Id));
                        }
                    });
                    set(state => {
                        state.menus = menus;
                        state.funcs = funcs;
                    });
                }
                return result;
            },
            setTopMenuCurrentId: (id) => {
                set(state => {
                    state.topmenu_id = id;
                });
            },
            getTopMenuFirstPage: (id) => {
                get(state => {

                });
            },
            setRouteNavigate(navigate) {
                set(state => {
                    state.route_navigate = navigate;
                })
            },
            setPrimaryColor(color) {
                set(state => {
                    state.primaryColor = color;
                })
            },
            updateDictData(name, data) {
                set(state => {
                    const index = state.sysdicts.findIndex(item => item.Name === name);
                    if (index > -1) {
                        state.sysdicts = [
                            ...state.sysdicts.slice(0, index),
                            ...state.sysdicts.slice(index + 1),
                            {
                                ...state.sysdicts[index],
                                Data: data,
                            }
                        ]

                    } else {
                        state.sysdicts = [
                            ...state.sysdicts,
                            {
                                Name: name,
                                Data: data,
                            }
                        ]
                    }

                })
            }
        }),
        {
            // 每个store唯一名称
            name: 'rust-red-storage',
        },
    )
    ;

export const useCommonStore = createSelectors(commonBaseStore);
export default useCommonStore;
export const useHydration = () => {
    const [hydrated, setHydrated] = useState(false);

    useEffect(() => {
        // Note: This is just in case you want to take into account manual rehydration.
        // You can remove the following line if you don't need it.
        // const unsubHydrate = useBoundStore.persist.onHydrate(() => setHydrated(false))
        const unsubFinishHydration = useCommonStore.persist.onFinishHydration(() => setHydrated(true))
        setHydrated(useCommonStore.persist.hasHydrated())
        return () => unsubFinishHydration();
    }, []);

    return hydrated
}